import {remCalc} from '_themeUtils'

const toast = {
    Toast: {
        baseStyle: () => ({
            wrapper: {
                alignItems: 'flex-start',
                w: '100%',
                bg: 'color.background.white',
                pt: 'spacing.4',
                pr: 'spacing.5',
                pb: 'spacing.6',
                pl: {base: 'spacing.4', md: 'spacing.8'},
                m: 0,
            },
            titleWrapper: {
                alignItems: 'center',
                justifyContent: 'space-between',
                w: '100%',
                pb: 'spacing.6',
            },
            title: {
                textStyle: 'displayXs',
                fontWeight: 500,
            },
            bodyWrapper: {
                alignItems: 'flex-start',
                w: '100%',
                gap: 'spacing.8',
            },
            productImage: {
                maxW: remCalc(83),
            },
            productImageSkeleton: {
                minW: remCalc(83),
                h: remCalc(105),
            },
            info: {
                alignItems: 'flex-start',
                w: '100%',
                alignSelf: 'stretch',
            },
            message: {
                textStyle: 'paragraphLg',
                letterSpacing: remCalc(0.7),
            },
            errorMessage: {
                color: 'color.text.error',
            },
            wishlistLink: {
                textStyle: 'paragraphXs',
                textTransform: 'none',
                letterSpacing: remCalc(1),
                fontWeight: 400,
                mt: 0,
                py: 'spacing.2',
            },
        }),
    },
}

export default toast
